var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "outline-photo-24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Downloadcenter",
    transform: "translate(-254.000000, -1218.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "outline-photo-24px",
    opacity: 0.5,
    transform: "translate(241.000000, 1205.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bounding_Boxes"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 104 0 104 104 0 104"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Outline",
    transform: "translate(13.000000, 13.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.3333333,8.66666667 L69.3333333,69.3333333 L8.66666667,69.3333333 L8.66666667,8.66666667 L69.3333333,8.66666667 Z M69.3333333,0 L8.66666667,0 C3.9,0 0,3.9 0,8.66666667 L0,69.3333333 C0,74.1 3.9,78 8.66666667,78 L69.3333333,78 C74.1,78 78,74.1 78,69.3333333 L78,8.66666667 C78,3.9 74.1,0 69.3333333,0 Z",
    id: "XMLID_48_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_46_",
    points: "48.2733333 38.3933333 35.2733333 55.1633333 26 43.94 13 60.6666667 65 60.6666667"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.5641c916825edbc8018f7b3d1761b665.svg";
export { ForwardRef as ReactComponent };